var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.00008 5H6.00008M5.00008 4V6M11.5001 4L11.0001 6M18.0001 5H20.0001M19.0001 4V6M15.0001 9L14.0001 10M18.0001 13L20.0001 12.5M18.0001 19H20.0001M19.0001 18V20M14.0001 16.518L7.48209 10L3.09209 19.58C3.00715 19.766 2.9811 19.9735 3.01741 20.1747C3.05371 20.3759 3.15066 20.5613 3.29524 20.7058C3.43982 20.8504 3.62514 20.9474 3.82636 20.9837C4.02758 21.02 4.23509 20.9939 4.42109 20.909L14.0001 16.518Z", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});